module.exports = __webpack_public_path__ + "img/c07_unitlogthrower_Normal_ua.55ffd316.webp";